import getHashPaths from './getHashPaths'

export default path => {
  if (!path) return false

  const hashPaths = getHashPaths().map(hashPath => hashPath.toLowerCase())

  return hashPaths.includes(path.toLowerCase())
}
